<template>
    <div>
        <div class="row">
            <div class="col-6">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <div>&nbsp;</div>
                        <h5 class="form-title">Email Preferences</h5>
                    </div>
                    <swell-switch
                        margin="mb-0"
                        truthyLabel="On"
                        falsyLabel="Off"
                        switch-label="Send Email?"
                        v-model="send_email"
                    />
                </div>
                <hr>
            </div>
            <div class="col-6">
                &nbsp;
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <input-text
                    label="Reply-to Email Address"
                    v-model="email.from_address"
                    :form="form"
                    placeholder="info@swellcx.com"
                    field="email_preference.from_address"
                />
                <message-template-selector
                    :message="email.from_name"
                    @messageUpdated="email.from_name = $event"/>
                <input-text label="From Name" v-model="email.from_name" />
                <input-text label="On Behalf Of" v-model="email.on_behalf_of" />
                <input-text label="Subject" v-model="email.subject" />
                <div class="row">
                  <div class="col-6">
                    <label for="email">Message</label>
                  </div>
                  <div class="col-6">
                    <message-template-selector
                        :message="email.message"
                        @messageUpdated="email.message = $event"/>
                  </div>
                </div>
                <textarea class="form-control" name="email" v-model="email.message"></textarea>
            </div>
            <div class="col-6">
                <div v-show="!email.use_location_image">
                    <upload-image image-label="Email image" v-model="email.image" :url="email.image_url" />
                </div>
                <div v-if="location_image_available">
                    <swell-switch
                        margin="mb-0"
                        truthyLabel="On"
                        falsyLabel="Off"
                        switch-label="Use Default Location Image"
                        v-model="email.use_location_image"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        props: {
            value: {
                type   : Object,
                default: function () {
                    return {};
                },
            },
            sendEmail: {
                type: Boolean
            },
            form : {
                required: true,
                type    : Object
            },
            location_image_available: {
                default: null
            }
        },

        data() {
            return {
                email: _.clone(this.value),
                send_email: this.sendEmail,
                variable: ''
            }
        },

        watch: {
            email: {
                handler(value) {
                    return this.$emit('input', value);
                },
                deep: true,
            },

            send_email() {
                this.$emit('sendEmail', this.send_email);
            }
        }
    }
</script>
